const context = require.context('../../assets/connectorImages', false, /\.(png|svg|jpe?g|webp)$/i)

const IMAGES = context.keys().reduce((images, key) => {
    const shortName = key.replace(/^\.\//, '').replace(/\.[^.]+$/, '').toLowerCase()
    images[shortName] = context(key)
    return images
}, {})

export const connectorImage = (shortName) => (shortName ? IMAGES[String(shortName).toLowerCase()] || null : null)
